import React, { createContext, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const ToastContext = createContext(); 

export const useToast = () => useContext(ToastContext);
export class ToastProvider extends React.Component {
  showToast = (message, options = {}) => {
    toast(message, { position: "top-right",autoClose: 10000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, ...options });
  };

  render() {
    return (
        <ToastContext.Provider value={this.showToast}>
        {this.props.children}
        <ToastContainer />
      </ToastContext.Provider>
    );
  }
}